import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { i18next, site } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import { MAX_SLUG_LENGTH } from 'src/js/modules/bindings/constants/slug';
import createBindingSlugValidator from 'src/js/modules/bindings/validators/create-binding-slug-validator';
import fieldNames from '../constants/field-names';

const { ControlGroup, InputGroupField } = designSystem;

function BindingField({ control, getFormValues, setFormValue, onChange, onClick }) {
  const activePageId = useSelector(site.selectors.getActivePageId);
  const bindings = useSelector((state) => site.selectors.getPageBindings(state, activePageId));
  const initialBindingVariableNameRef = useRef(getFormValues(fieldNames.BINDING_SLUG) || '');

  useEffect(() => {
    if (getFormValues(fieldNames.BINDING_ID)) {
      return;
    }

    setFormValue(fieldNames.BINDING_ID, site.helpers.generateId());
  }, [getFormValues, setFormValue]);

  const handleChange = useCallback(
    (value) => {
      onChange({
        fieldName: fieldNames.BINDING_SLUG,
        fieldValue: value,
      });
    },
    [onChange]
  );

  const handleClick = useCallback(() => {
    onClick({ fieldName: fieldNames.BINDING_SLUG });
  }, [onClick]);

  return (
    <ControlGroup title={i18next.t('Variable name')} required>
      <InputGroupField
        name={fieldNames.BINDING_SLUG}
        control={control}
        maxLength={MAX_SLUG_LENGTH}
        rules={{
          validate: createBindingSlugValidator({
            bindings,
            existingSlug: initialBindingVariableNameRef.current,
          }),
        }}
        onChange={handleChange}
        onClick={handleClick}
      />
    </ControlGroup>
  );
}

BindingField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  getFormValues: PropTypes.func.isRequired,
  setFormValue: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BindingField;
